import { create } from "zustand";
import type { Hint } from "../types";

interface MedicationsState {
  medications: Hint[];
  setMedications: (medications: Hint[]) => void;
}

export const useMedicationsStore = create<MedicationsState>((set) => ({
  medications: [],
  setMedications: (medications: Hint[]) => set({ medications }),
}));
